export default "__VITE_ASSET__909d9a1e__"